import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

import ProgressSpinner from '../components/ProgressSpinner'

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: () => ({
                component: import('../views/HomeDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/users',
            name: 'users',
            component: () => ({
                component: import('../views/Users'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/roles',
            name: 'roles',
            component: () => ({
                component: import('../views/Roles'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/dossier',
            name: 'dossiers',
            component: () => ({
                component: import('../views/Dossiers'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/dossier/:id/dashboard',
            name: 'dossier-dashboard',
            component: () => ({
                component: import('../views/DossierDashboard'),
                loading: ProgressSpinner
            }),
            props: true
        },
        {
            path: '/orcamentos',
            name: 'orcamentos',
            component: () => ({
                component: import('../modules/orcamento/OrcamentoLista'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/arquivo',
            name: 'arquivo',
            component: () => ({
                component: import('../views/Arquivo'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/orcamentos/:id',
            name: 'orcamento',
            props: true,
            component: () => ({
                component: import('../modules/orcamento/Orcamento'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/prdcompostos',
            name: 'prdcompostos',
            component: () => ({
                component: import('../views/PrdCompostos'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/prdcompostos/:id',
            name: 'prdcomposto',
            props: true,
            component: () => ({
                component: import('../views/PrdComposto'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/config/arquivo',
            name: 'folder-config',
            component: () => ({
                component: import('../views/FolderConfig'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/dictionary',
            name: 'dictionary-config',
            component: () => ({
                component: import('../views/DictionaryConfig'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/warehouses',
            name: 'warehouse-management',
            component: () => ({
                component: import('../views/WarehouseManage'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/config/processtype',
            name: 'process-type-config',
            component: () => ({
                component: import('../views/ConfigProcessType'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/config/charges_types',
            name: 'estimate-charges-types',
            component: () => ({
                component: import('../views/EstimateChargesTypes'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/suppliers_inquiry',
            name: 'suppliers-inquiry',
            component: () => ({
                component: import('../views/SuppliersInquiry'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/suppliers_inquiry/:id',
            name: 'supplier-row',
            component: () => ({
                component: import('../views/SupplierRow'),
                loading: ProgressSpinner
            }),
            props: true
        },
        {
            path: '/batches',
            name: 'batch-management',
            component: () => ({
                component: import('../views/Batches'),
                loading: ProgressSpinner
            })
        },
        // {
        //     path: '/support',
        //     name: 'support-page',
        //     component: () => ({
        //         component: import('../views/Support'),
        //         loading: ProgressSpinner
        //     })
        // },
        {
            path: '/supplier_requests',
            name: 'supplier-requests',
            component: () => ({
                component: import('../views/SupplierRequest'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/supplier_requests/:id',
            name: 'supplier-request-row',
            component: () => ({
                component: import('../views/SupplierRequestRow'),
                loading: ProgressSpinner
            }),
            props: true
        },
        {
            path: '/expenses',
            name: 'ListaFichaCaixa',
            component: () => ({
                component: import('../modules/FichaCaixa/Lista'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/expenses/:id',
            name: 'FichaCaixa',
            component: () => ({
                component: import('../modules/FichaCaixa/Item'),
                loading: ProgressSpinner
            }),
            props: true
        },
        {
            path: '/inquiries_comparison',
            name: 'inquiries-dashboard',
            component: () => ({
                component: import('../views/InquiriesDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/product_verification',
            name: 'product-verification',
            component: () => ({
                component: import('../views/ProductVerification'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/material_reception',
            name: 'material-reception',
            component: () => ({
                component: import('../views/MaterialReception'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/stocks_inquiry',
            name: 'stock-inquiry',
            component: () => ({
                component: import('../views/StockInquiry'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/warehouse_movements',
            name: 'warehouse-movements',
            component: () => ({
                component: import('../views/WarehouseMovement'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/rating',
            name: 'ratings-config',
            component: () => ({
                component: import('../views/Ratings'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/material_reception_list',
            name: 'material-receptions-list',
            component: () => ({
                component: import('../views/MaterialReceptionList'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/construction_warehouse_movements',
            name: 'construction-warehouse-movements',
            component: () => ({
                component: import('../views/ConstructionWarehouseMovement'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/epi_risk_management',
            name: 'epi-risk-management',
            component: () => ({
                component: import('../views/EpiRiskManagement'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/material_returns',
            name: 'material-return',
            component: () => ({
                component: import('../views/MaterialReturn'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/ep_management',
            name: 'protection-equipments',
            component: () => ({
                component: import('../views/EPManagement'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/ep_management/:id/dashboard',
            name: 'epi-management-dashboard',
            props: true,
            component: () => ({
                component: import('../views/EpiManagementDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/epi_movement',
            name: 'epi-movements',
            component: () => ({
                component: import('../views/EpiMovement'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/loss_reasons',
            name: 'loss-reasons',
            component: () => ({
                component: import('../views/LossReasons'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/human_resources',
            name: 'human-resources',
            component: () => ({
                component: import('../views/HumanResources'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/human_resources/:id/dashboard',
            name: 'human-resources-dashboard',
            props: true,
            component: () => ({
                component: import('../views/HumanResourcesDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/vehicle_management',
            name: 'vehicle-management',
            component: () => ({
                component: import('../views/VehicleManagement'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/equipments',
            name: 'equipment-management',
            component: () => ({
                component: import('../views/EquipmentManagement'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/vehicle_management/:id/dashboard',
            name: 'vehicle-management-dashboard',
            props: true,
            component: () => ({
                component: import('../views/VehicleManagementDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/equipments/:id/dashboard',
            name: 'equipment-management-dashboard',
            props: true,
            component: () => ({
                component: import('../views/EquipmentManagementDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/equipment_movement',
            name: 'equipment-movement-dashboard',
            component: () => ({
                component: import('../views/EquipmentMovementDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/equipment_type_management',
            name: 'equipment-type-management',
            component: () => ({
                component: import('../views/EquipmentTypeManagement'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/verification_type',
            name: 'verification-types',
            component: () => ({
                component: import('../views/VerificationTypes'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/equipment_verifications',
            name: 'equipment-verification',
            component: () => ({
                component: import('../views/EquipmentVerification'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/equipment_verifications/:id/dashboard',
            name: 'equipment-verification-dashboard',
            props: true,
            component: () => ({
                component: import('../views/EquipmentVerificationDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/epi_employee',
            name: 'epi-employees',
            component: () => ({
                component: import('../views/EpiEmployees'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/kinship_management',
            name: 'kinship-management',
            component: () => ({
                component: import('../views/KinshipManagement'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/ep_verifications',
            name: 'protection-equipments-verification',
            component: () => ({
                component: import('../views/EPVerification'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/ep_verifications/:id/dashboard',
            name: 'epi-verification-dashboard',
            props: true,
            component: () => ({
                component: import('../views/EpiVerificationDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/material_movement_list',
            name: 'material-movements-list',
            component: () => ({
                component: import('../views/MaterialMovementsList'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/fuel_types',
            name: 'fuel-types',
            component: () => ({
                component: import('../views/FuelTypes'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/vehicle_inspection',
            name: 'vehicle-inspection',
            component: () => ({
                component: import('../views/VehicleInspection'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/vehicle_inspection/:id/dashboard',
            name: 'vehicle-inspection-dashboard',
            props: true,
            component: () => ({
                component: import('../views/VehicleInspectionDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/employee_vacation_map',
            name: 'employees-vacation-map',
            component: () => ({
                component: import('../views/EmployeesVacationMap'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/claim_circumstances',
            name: 'vehicle-claim-curcumstance',
            component: () => ({
                component: import('../views/VehicleClaimCircumstance'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/claims_management',
            name: 'vehicle-claim-management',
            component: () => ({
                component: import('../views/VehicleClaimManagement'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/claims_management/:id/dashboard',
            name: 'vehicle-claim-management-dashboard',
            props: true,
            component: () => ({
                component: import('../views/VehicleClaimManagementDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/holidays_management',
            name: 'holiday-management',
            component: () => ({
                component: import('../views/HolidayManagement'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/expense-type',
            name: 'ExpenseType',
            component: () => ({
                component: import('../views/ExpenseTypes'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/roles/:id/dashboard',
            name: 'roles-dashboard',
            props: true,
            component: () => ({
                component: import('../views/RolesDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/expenses-management',
            name: 'ExpensesManagement',
            component: () => ({
                component: import('../modules/FichaCaixa/MgmtList'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/expenses-management/:id',
            name: 'ExpensesManagementItem',
            props: true,
            component: () => ({
                component: import('../modules/FichaCaixa/Item'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/inspection_rules',
            name: 'inspection-rule',
            component: () => ({
                component: import('../views/InspectionRuleManagement'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/vacation_plans',
            name: 'vacation-plans',
            component: () => ({
                component: import('../views/VacationPlansYear'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/suppliers_inquiry/:inquiryID/line/:id',
            name: 'supplier-row-edit',
            component: () => ({
                component: import('../views/SupplierRowEdit'),
                loading: ProgressSpinner
            }),
            props: true
        },
        {
            path: '/proposal_types',
            name: 'proposal-types',
            component: () => ({
                component: import('../views/ProposalTypes'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/vehicle_intervention_types',
            name: 'vehicle-intervention-types',
            component: () => ({
                component: import('../views/VehicleInterventionTypes'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/epc_movement',
            name: 'epc-movement-dashboard',
            component: () => ({
                component: import('../views/EpcMovementDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/supplier_verification',
            name: 'supplier-verification',
            component: () => ({
                component: import('../views/SupplierVerification'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/batches/:id/dashboard',
            name: 'batches-dashboard',
            props: true,
            component: () => ({
                component: import('../views/BatchesDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/users/:id/dashboard',
            name: 'users-dashboard',
            props: true,
            component: () => ({
                component: import('../views/UsersDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/access_records',
            name: 'access-records',
            component: () => ({
                component: import('../views/AccessRecords'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/construction_planning',
            name: 'construction-planning',
            component: () => ({
                component: import('../views/ConstructionPlanning'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/weekly_planning',
            name: 'weekly-construction-planning',
            component: () => ({
                component: import('../views/WeeklyConstructionPlanning'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/tasks',
            name: 'production-tasks',
            component: () => ({
                component: import('../views/ProductionTasks'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/tasks/:id/dashboard',
            name: 'production-tasks-dashboard',
            props: true,
            component: () => ({
                component: import('../views/ProductionTasksDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/task_list_management',
            name: 'production-task-list-management',
            component: () => ({
                component: import('../views/ProductionTaskListManagement'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/task_list_management/:id/dashboard',
            name: 'production-task-list-management-dashboard',
            props: true,
            component: () => ({
                component: import('../views/ProductionTaskListManagementDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/pending_tasks',
            name: 'production-pending-list',
            component: () => ({
                component: import('../views/ProductionPendingList'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/pending_tasks/:id/dashboard',
            name: 'production-pending-list-dashboard',
            props: true,
            component: () => ({
                component: import('../views/ProductionPendingListDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/task_lists',
            name: 'production-task-listing',
            component: () => ({
                component: import('../views/ProductionTaskListing'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/task_lists/:id/dashboard',
            name: 'task-lists-list-dashboard',
            props: true,
            component: () => ({
                component: import('../views/ProductionPendingListDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/dossier/:dossier/dashboard/:id/lists',
            name: 'dossier-lists-list-dashboard',
            props: true,
            component: () => ({
                component: import('../views/ProductionPendingListDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/it_equipment_types',
            name: 'it-equipment-types',
            component: () => ({
                component: import('../views/ItEquipmentTypes'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/it_equipment_event_types',
            name: 'it-equipment-event-types',
            component: () => ({
                component: import('../views/ItEquipmentEventTypes'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/it_equipment_accessory_types',
            name: 'it-equipment-accessory-types',
            component: () => ({
                component: import('../views/ItEquipmentAccessoryTypes'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/it_equipment_event_seriousness',
            name: 'it-equipment-event-seriousness',
            component: () => ({
                component: import('../views/ItEquipmentEventSeriousness'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/it_equipment_event_status',
            name: 'it-equipment-event-status',
            component: () => ({
                component: import('../views/ItEquipmentEventStatus'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/ficha_diaria_servico',
            name: 'daily-service-form',
            component: () => ({
                component: import('../views/DailyServiceForm'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/it_equipment',
            name: 'it-equipment-info',
            component: () => ({
                component: import('../views/ItEquipmentInfo'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/it_equipment/:id/dashboard',
            name: 'it-equipment-info-dashboard',
            props: true,
            component: () => ({
                component: import('../views/ItEquipmentInfoDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/it_equipment_users',
            name: 'it-equipment-users',
            component: () => ({
                component: import('../views/ItEquipmentUsers'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/it-equipment-users-dashboard/:user_id/dashboard',
            name: 'it-equipment-users-dashboard',
            props: true,
            component: () => ({
                component: import('../views/ItEquipmentUsersDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/software-licenses/:software_id',
            name: 'software-licenses',
            props: true,
            component: () => ({
                component: import('../views/ItEquipmentLicenses'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/it-equipment-license-dashboard/:software_id/dashboard',
            name: 'it-equipment-license-dashboard',
            props: true,
            component: () => ({
                component: import('../views/ItEquipmentLicensesDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/it_equipment_tickets',
            name: 'it-equipment-tickets-dashboard',
            component: () => ({
                component: import('../views/ItEquipmentTicketDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/sys/supplier',
            name: 'sys_supplier',
            component: () => ({
                component: import('../modules/115_sys_supplier/Lista'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/sys/cost_center',
            name: 'sys_cost_center',
            component: () => ({
                component: import('../modules/116_sys_cost_center/Lista'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/it_user_tickets',
            name: 'it_user_tickets',
            component: () => ({
                component: import('../views/ItEquipmentUserTickets'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/ficha_diaria_servico/:id/dashboard',
            name: 'daily-service-form-dashboard',
            props: true,
            component: () => ({
                component: import('../views/DailyServiceFormDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/building_management',
            name: 'building-management',
            component: () => ({
                component: import('../views/BuildingManagement'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/consulta_fichas_servico',
            name: 'daily-service-forms-inquiry',
            component: () => ({
                component: import('../views/DailyServiceFormsInquiry'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/building_management/:id/dashboard',
            name: 'building-management-dashboard',
            props: true,
            component: () => ({
                component: import('../views/BuildingManagementDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/consulta_fichas_servico/:id/dashboard',
            name: 'daily-service-forms-inquiry-dashboard',
            props: true,
            component: () => ({
                component: import('../views/DailyServiceFormDashboard'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/sys/client',
            name: 'sys_client',
            component: () => ({
                component: import('../modules/sys_client/Lista'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/sys/product_family',
            name: 'sys_product_family',
            component: () => ({
                component: import('../modules/sys_fam_artigos/Lista'),
                loading: ProgressSpinner
            }), 
            props: (route) => ({ 
                parent: (route.query.parent != undefined ? route.query.parent : 0),
                description: (route.query.description != undefined ? route.query.description : '')
            })
        },
        {
            path: '/development_entities',
            name: 'development_entities',
            component: () => ({
                component: import('../modules/78_development_entities/DevelopmentEntities'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/doctors',
            name: 'doctors',
            component: () => ({
                component: import('../modules/79_doctors/Doctors'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/vehicle_insurance_types',
            name: 'vehicle_insurance_types',
            component: () => ({
                component: import('../modules/80_vehicle_insurance_types/VehicleInsuranceTypes'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/vehicle_insurance_entities',
            name: 'vehicle_insurance_entities',
            component: () => ({
                component: import('../modules/81_vehicle_insurance_entities/VehicleInsuranceEntities'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/vehicle_license_types',
            name: 'vehicle_license_types',
            component: () => ({
                component: import('../modules/90_vehicle_license_types/VehicleLicenseTypes'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/sys/product',
            name: 'sys_product',
            component: () => ({
                component: import('../modules/sys_products/Lista'),
                loading: ProgressSpinner
            }),
            props: (route) => ({
                family: (route.query.family != undefined ? route.query.family : undefined),
                subfamily: (route.query.subfamily != undefined ? route.query.subfamily : undefined),
            })
        },
        {
            path: '/events/composite-product',
            name: 'ev_comp_product_list',
            component: () => ({
                component: import('../modules/ev_comp_products/Lista'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/events/composite-product/:id/components',
            name: 'ev_comp_product_comp',
            props: true,
            component: () => ({
                component: import('../modules/ev_comp_products/Components'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/team',
            name: 'teams_list',
            component: () => ({
                component: import('../modules/teams/Lista'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/team/:id',
            name: 'teams_item',
            props: true,
            component: () => ({
                component: import('../modules/teams/Item'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/events/stock-movement',
            name: 'ev_stock_movement_list',
            component: () => ({
                component: import('../modules/ev_stock_movement/Lista'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/events/stock-in-out',
            name: 'ev_in_and_out',
            component: () => ({
                component: import('../views/74_Home'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/event/estimate',
            name: 'event-estimates',
            component: () => ({
                component: import('../modules/75_events_estimates/Lista'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/event/estimate/:id',
            name: 'event-estimate',
            props: true,
            component: () => ({
                component: import('../modules/75_events_estimates/Item'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/user_weekly_planning',
            name: 'user-weekly-planning',
            component: () => ({
                component: import('../modules/76_user_weekly_planning/UserWeeklyPlanning'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/sys/department',
            name: 'sys_department',
            component: () => ({
                component: import('../modules/77_sys_department/Lista'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/events/unavailable-stock',
            name: 'ev_unavailable_stock',
            component: () => ({
                component: import('../modules/82_ev_unavailable_stock/Lista'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/service-form/types',
            name: 'service-form-types',
            component: () => ({
                component: import('../views/ServiceFormTypes'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/service-form/templates',
            name: 'service_form_templates_list',
            component: () => ({
                component: import('../modules/dsf_templates/Lista'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/service-form/register',
            name: 'service_form_list',
            component: () => ({
                component: import('../modules/92_service_forms/Lista'),
                loading: ProgressSpinner
            }),
            props: (route) => ({ 
                process_id: route.query.process_id,
                work_day: route.query.work_day,
                type_id: route.query.type_id,
            }),
        },
        {
            path: '/report/event/estimate',
            name: 'ev_estimate_reports',
            component: () => ({
                component: import('../modules/93_ev_estimate_reports/Home.vue'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/report/product',
            name: 'product_reports',
            component: () => ({
                component: import('../modules/94_product_reports/Home.vue'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/events/stock',
            name: 'events-stock',
            component: () => ({
                component: import('../modules/95_events_stock/Lista'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/daily-execution',
            name: 'daily-execution',
            component: () => ({
                component: import('../modules/96_daily_execution/Lista'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/time-clock',
            name: 'time-clock',
            component: () => ({
                component: import('../modules/97_time_clock/Lista'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/human-resource/stock/movement',
            name: 'rh_in_and_out',
            component: () => ({
                component: import('../modules/98_rh_in_and_out/Lista'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/approve-time-clock',
            name: 'approve-time-clock',
            component: () => ({
                component: import('../modules/99_time_clock_approval/Lista'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/dispute-time-clock',
            name: 'dispute-time-clock',
            component: () => ({
                component: import('../modules/100_contest_time_clock/Lista'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/sys/employee-category',
            name: 'employee-category',
            component: () => ({
                component: import('../modules/101_sys_employee_category/Lista'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/employee/vacations-absences',
            name: 'employee-vacations-absences',
            component: () => ({
                component: import('../modules/102_vacations_absences/Lista'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/s/process',
            name: 'simpler-process',
            component: () => ({
                component: import('../modules/103_simpler_process/Lista'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/s/process/:id',
            name: 'simpler-process-item',
            component: () => ({
                component: import('../modules/103_simpler_process/Item'),
                loading: ProgressSpinner
            }),
            props: true
        },
        {
            path: '/service-form/view',
            name: 'service_form_view',
            props: (route) => ({ 
                process_id: route.query.process_id,
                work_day: route.query.work_day,
                type_id: route.query.type_id,
            }),
            component: () => ({
                component: import('../modules/104_service_forms_view/Lista'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/view-time-clock',
            name: 'view_time_clock',
            component: () => ({
                component: import('../modules/105_apv_time_clock_view/Lista'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/service-form/custom-control',
            name: 'service_form_custom_controls',
            component: () => ({
                component: import('../modules/106_service_form_custom_controls/Lista'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/event/simulator',
            name: 'event_service_order_simulator',
            component: () => ({
                component: import('../modules/107_event_service_order_sim/Main'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/weekly-execution',
            name: 'weekly-construction-execution',
            component: () => ({
                component: import('../views/WeeklyConstructionPlanning'),
                loading: ProgressSpinner
            }),
            props: () => ({
                type: 2,
            })
        },
        {
            path: '/contacts',
            name: 'contacts',
            component: () => ({
                component: import('../modules/109_contacts/Lista'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/event/programming',
            name: 'ev_programming',
            component: () => ({
                component: import('../modules/110_ev_programming/Lista'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/workshop/maintenance',
            name: 'maintenance',
            component: () => ({
                component: import('../modules/111_maintenance/Lista'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/workshop/maintenance-request',
            name: 'maintenance_request',
            component: () => ({
                component: import('../modules/112_maintenance_reqs/Lista'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/signaling/stock-in-out',
            name: 'sg_in_and_out',
            component: () => ({
                component: import('../views/74_Home'),
                loading: ProgressSpinner
            }), 
        },
        {
            path: '/service-form/approve',
            name: '114_service_forms_approve',
            component: () => ({
                component: import('../modules/114_service_forms_approve/Lista'),
                loading: ProgressSpinner
            }),
            props: (route) => ({ 
                process_id: route.query.process_id,
                work_day: route.query.work_day,
                type_id: route.query.type_id,
            }),
        },
        {
            path: '/execution-status',
            name: '117_execution_status',
            component: () => ({
                component: import('../modules/117_execution_status/Lista'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/stock/on-maintenance',
            name: '118_stock_on_maintenance',
            component: () => ({
                component: import('../modules/118_stock_on_maintenance/Lista'),
                loading: ProgressSpinner
            }),
        },
        {
            path: '/locations',
            name: 'locations',
            component: () => ({
                component: import('../modules/119_locations/Locations'),
                loading: ProgressSpinner
            })
        },
        {
            path: '/salaries',
            name: 'salaries',
            component: () => ({
                component: import('../modules/120_salaries/Lista'),
                loading: ProgressSpinner
            })
        },

        // resources\js\modules\106_service_form_custom_controls\Lista.vue
        // {
        //     path: '/sys/client/:id',
        //     name: 'sys_client_form',
        //     component: () => ({
        //         component: import('../modules/sys_client/Form'),
        //         loading: ProgressSpinner
        //     })
        // },
        {
            path: '*',
            redirect: '/'
        }
    ],
});

export default router


// WEBPACK FOOTER //
// ./resources/js/router/index.js